// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"270":"19ef1538","577":"f820a59e","634":"0de59108","640":"14c3a27a","714":"cc357cf3"}[chunkId] + ".js";
};